export const STRIPE_PK = 'pk_live_gOyoHjo3QNweXjfoiQJBOSHF'
